import axios from "axios";
import { useState } from "react";
  

const useSetDeviceSetting = (
  token: string | null | undefined,
  userId: string | undefined,
  deviceId: string | undefined
) => {
  const baseUrl = process.env.REACT_APP_API_URL;

  const [response, setResponse] = useState();
  const [error, setError] = useState("");
  const [loading, setloading] = useState(true);

  const fetch = (data: { [key: string]: any }) => {
    axios({
      method: "post",
      url: `${baseUrl}/api/devices/${userId}/${deviceId}/settings`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        deviceId: deviceId,
        type: "Set device option",
        alias: data.alias,
        data: JSON.stringify(data.data),
      },
    })
      .then((res) => {
        setResponse(res.data);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setloading(false);
      });
  };

  return { response, error, loading, fetch };
};

export default useSetDeviceSetting;
